module.exports = "/packs/plus-gray-832cac549a75b7b6e98878e35399eb08.svg";